import $ from 'jquery'
import 'slick-carousel'
import { bp } from '../../../assets/src/scripts/core.js'

export class AutoCarousel {
  constructor ($container) {
    this.$container = $container
    this.$slider = $container.find('.auto-carousel-slider')

    // Pas de carousel s'il n'y a qu'une seule slide
    if (!this.$slider.length || this.$slider.children().length < 2) {
      return
    }

    this.$tabs = $container.find('.auto-carousel-tab')
    this.$bars = $container.find('.auto-carousel-tab-progress-bar')
    this.$toggle = $container.find('.auto-carousel-toggle')

    this.speed = parseInt(this.$slider.data('autoplay-speed'), 10) || 5000
    this.isPaused = false
    this.elapsed = 0
    this.lastTs = null
    this.raf = null
    this.current = 0

    this.tick = this.tick.bind(this)

    this.$slider.on('beforeChange', this.onBeforeChange.bind(this))
    this.$slider.on('afterChange', this.onAfterChange.bind(this))
    this.$tabs.on('click', this.onTabClick.bind(this))
    this.$toggle.on('click', this.onToggle.bind(this))

    this.$slider.slick({
      mobileFirst: true,
      infinite: true,
      arrows: false,
      speed: 600,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      fade: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: bp.lg,
          settings: {
            dots: false,
            fade: true,
            adaptiveHeight: false
          }
        }
      ]
    })

    this.startProgress()
  }

  /**
   * Démarre / redémarre la barre de progression de la slide courante
   */
  startProgress () {
    this.elapsed = 0
    this.lastTs = null
    this.$bars.css('width', '0%')
    this.setProgress(0)

    if (this.raf) {
      window.cancelAnimationFrame(this.raf)
    }
    this.raf = window.requestAnimationFrame(this.tick)
  }

  tick (ts) {
    if (this.lastTs === null) {
      this.lastTs = ts
    }

    if (!this.isPaused) {
      this.elapsed += ts - this.lastTs
    }
    this.lastTs = ts

    let percent = Math.min(100, (this.elapsed / this.speed) * 100)
    // Desktop : barre linéaire de l'onglet courant
    this.$bars.eq(this.current).css('width', percent + '%')
    // Mobile : anneau de progression autour de la puce active (via variable CSS)
    this.setProgress(percent)

    if (percent >= 100) {
      this.$slider.slick('slickNext')
      return
    }

    this.raf = window.requestAnimationFrame(this.tick)
  }

  setProgress (percent) {
    this.$slider[0].style.setProperty('--auto-carousel-progress', percent)
  }

  onBeforeChange () {
    // Remise à zéro pendant la transition : évite que la prochaine puce active
    // hérite d'un anneau plein (la variable CSS est partagée)
    if (this.raf) {
      window.cancelAnimationFrame(this.raf)
      this.raf = null
    }
    this.$bars.css('width', '0%')
    this.setProgress(0)
  }

  onAfterChange (event, slick, currentSlide) {
    this.current = currentSlide

    this.$tabs.removeClass('is-active')
    this.$tabs.eq(currentSlide).addClass('is-active')

    this.startProgress()
  }

  onTabClick (event) {
    let index = parseInt($(event.currentTarget).data('index'), 10)
    this.$slider.slick('slickGoTo', index)
  }

  onToggle () {
    this.isPaused = !this.isPaused
    this.$container.toggleClass('is-paused', this.isPaused)
  }
}
